import { sectionWrap, escapeHtml } from "./factories";
import {
  SOCIAL_PLATFORMS,
  SOCIAL_PLACEMENTS,
  getSocialIconMarkup,
  normalizeSocialLinks,
} from "../socialLinks";

export { SOCIAL_PLATFORMS, SOCIAL_PLACEMENTS, getSocialIconMarkup, normalizeSocialLinks };

export function makeSocialIconsBlock(links = {}, placement = SOCIAL_PLACEMENTS.BODY_BLOCK) {
  const normalizedLinks = normalizeSocialLinks(links);
  const icons = SOCIAL_PLATFORMS
    .filter((p) => normalizedLinks[p.key])
    .map(
      (p) => `
      <a href="${escapeHtml(normalizedLinks[p.key])}"
        target="_blank"
        rel="noopener noreferrer"
        data-social="${p.key}"
        style="
          display:inline-flex;
          align-items:center;
          justify-content:center;
          width:36px;
          height:36px;
          border-radius:50%;
          background:${p.color};
          color:#ffffff;
          text-decoration:none;
        "
        title="${escapeHtml(p.label)}"
      >${getSocialIconMarkup(p)}</a>
    `
    )
    .join("");

  const placeholder = !icons
    ? `<span style="color:rgba(0,0,0,0.3);font-size:12px;">Add social links via the settings panel</span>`
    : "";

  return sectionWrap(
    `
    <div style="
      text-align:center;
      padding:16px 0;
      margin:12px 0;
    " data-social-icons data-social-placement="${escapeHtml(placement)}">
      <div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">
        ${icons || placeholder}
      </div>
    </div>
    `,
    "social-icons"
  );
}
